module.exports = __webpack_public_path__ + "static/media/profile.b76f37a9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/profile/profile.svg
// module id = 12
// module chunks = 0